"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIssuesQueryClientInstance = void 0;
var _reactQuery = require("@tanstack/react-query");
const getIssuesQueryClientInstance = () => {
  // We want a shared symbol which can be accessed between bundles and apps
  const sym = Symbol.for("issues-query-client");
  if (!window[sym]) {
    window[sym] = new _reactQuery.QueryClient({
      // default options when feature flag is off
      defaultOptions: {
        queries: {
          // How much time we save data in cache
          cacheTime: Infinity,
          // until next refresh
          // How long we do not re-fetch fresh data in the background
          staleTime: 5 * 60 * 1000 // 5 minutes
        }
      }
    });
  }
  return window[sym];
};
exports.getIssuesQueryClientInstance = getIssuesQueryClientInstance;
//# sourceMappingURL=index.js.map